import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { persistStorage } from '@/lib/storage'

/** Free-plan limit (D19); Pro limits are decided later (D7). */
export const WATCHLIST_LIMIT = 10
export const WATCHLIST_KEY = 'gx-watchlist'

export type ToggleResult = 'added' | 'removed' | 'full'

/** Pure toggle used by the store (and tests): newest first, capped at `limit`. */
export function toggleWatch(ids: string[], id: string, limit = WATCHLIST_LIMIT): { ids: string[]; result: ToggleResult } {
  if (ids.includes(id)) return { ids: ids.filter((x) => x !== id), result: 'removed' }
  if (ids.length >= limit) return { ids, result: 'full' }
  return { ids: [id, ...ids], result: 'added' }
}

interface WatchlistState {
  ids: string[]
  toggle: (id: string) => ToggleResult
  clear: () => void
}

export const useWatchlist = create<WatchlistState>()(
  persist(
    (set, get) => ({
      ids: [],
      toggle: (id) => {
        const { ids, result } = toggleWatch(get().ids, id)
        if (result !== 'full') set({ ids })
        return result
      },
      clear: () => set({ ids: [] }),
    }),
    {
      name: WATCHLIST_KEY,
      storage: persistStorage,
      version: 1,
      partialize: ({ ids }) => ({ ids }),
    },
  ),
)
